import { BRAND_NAMES, DEFAULT_BRAND, IconBrands, IconSizes, URL_FOR_BRAND, availableIcons, svgSourceBaseUrl } from './constants';
import { Colors } from '../theming';
import ReactDOMServer from 'react-dom/server';
import { availableTypes } from './availableIcons';
/**
 * encodeIconSVG
 * Takes a React SVG Component (like a Prism Icon) and outputs a URL-encoded
 * string so the component can be used in CSS properties like
 * `background-image`
 * @param {ReactComponent} data
 * Logic adapted from https://github.com/yoksel/url-encoder
 */

export var encodeIconSVG = function encodeIconSVG(data) {
  var symbols = /[\r\n%#()<>?[\\\]^`{|}]/g;
  data = ReactDOMServer.renderToString(data);
  data = data.replace(/"/g, "'");
  data = data.replace(/>\s{1,}</g, '><');
  data = data.replace(/\s{2,}/g, ' ');

  if (data.indexOf('http://www.w3.org/2000/svg') < 0) {
    data = data.replace(/<svg/g, "<svg xmlns='http://www.w3.org/2000/svg'");
  }

  data = data.replace(symbols, encodeURIComponent);
  return data;
};
export var createIconColors = function createIconColors() {
  var colorsObj = {
    CurrentColor: 'currentColor'
  };
  Object.keys(Colors).forEach(function (colorName) {
    colorsObj[colorName] = colorName;
    colorsObj[Colors[colorName]] = Colors[colorName];
  });
  return colorsObj;
};
/**
 * createSvgUrl
 * Takes the icon brand and the type key to create
 * the url for fetching the SVG from our S3 bucket
 * @param {string} brand
 * @param {string} iconKey
 */

export var createSvgUrl = function createSvgUrl(brand, iconKey) {
  return "".concat(svgSourceBaseUrl).concat(brand === BRAND_NAMES[IconBrands.Caviar] ? URL_FOR_BRAND.Caviar : URL_FOR_BRAND.DoorDash).concat(availableIcons[brand][iconKey]);
};
/**
 * getIconBrand
 * Takes the theme's `Icons.Brand` override and the desired
 * Icon type to determine availability. If icon type is not
 * available for the brand override, default to the
 * DoorDash variant of that Icon type.
 * @param {string} themeBrand
 * @param {string} type
 */

export var getIconBrand = function getIconBrand(themeBrand, type) {
  var themeBrandName = BRAND_NAMES[themeBrand];

  if (themeBrandName && availableTypes[themeBrandName][type]) {
    return themeBrandName;
  }

  if (availableTypes[DEFAULT_BRAND][type]) {
    return DEFAULT_BRAND;
  }

  return null;
};
/**
 * iconAvailabilityKey
 * Takes the icon brand, size, and type to determine which
 * variant of the icon to use.
 * Use 16 for <= IconSizes.Small, and 24 for > IconSizes.Small
 * Size "up" the 16 variant if a 24 variant is unavailable for
 * large sizes, size "down" the 24 variant if a 16 variant
 * is unavailable for small sizes.
 * @param {object} info
 * @param {string} info.brand
 * @param {string} info.size
 * @param {string} info.type
 */

export var iconAvailabilityKey = function iconAvailabilityKey(_ref) {
  var brand = _ref.brand,
      size = _ref.size,
      type = _ref.type;

  if (size <= IconSizes.Small) {
    // if the size is <=16 and there is NOT a 16 variant, render the 24 variant
    if (!availableIcons[brand]["16".concat(type)]) {
      return "24".concat(type);
    } // if the size is <=16 and there is a 16 variant, render the 16 variant


    return "16".concat(type);
  } // if the size is >16 and there is NOT a 24 variant, render the 16 variant


  if (!availableIcons[brand]["24".concat(type)]) {
    return "16".concat(type);
  } // if the size is >16 and there is a 24 variant, render the 24 variant


  return "24".concat(type);
};
/**
 * svgAttrUpdates
 * Takes a stringified SVG and applies any desired color overrides
 * @param {object} svgInfo
 * @param {string} svgInfo.code - default version of svg asset
 * @param {string} svgInfo.iconColor - desired fill color
 * @param {boolean} svgInfo.useDefaultColors - whether or not to override default fills
 */

export var svgAttrUpdates = function svgAttrUpdates(_ref2) {
  var code = _ref2.code,
      iconColor = _ref2.iconColor,
      useDefaultColors = _ref2.useDefaultColors;
  var iconSvgString = code;

  if (!useDefaultColors) {
    iconSvgString = iconSvgString.replace(/fill="(?!none).*?"/g, "fill=\"".concat(iconColor, "\""));
    iconSvgString = iconSvgString.replace(/stroke="(?!none).*?"/g, "stroke=\"".concat(iconColor, "\""));
  }

  return iconSvgString;
};
/**
 * svgErrorHandler
 * Takes an error object and a callback
 * Warns the user about the error in the console and
 * calls the callback with `true`
 * @param {object} error
 * @param {function} handleSvgFetchError
 */

export var svgErrorHandler = function svgErrorHandler(error, handleSvgFetchError) {
  /* eslint-disable no-console */
  console.warn("Unable to fetch icon file. Error message: ".concat(error.message));
  console.warn('Please reach out to Design Infrastructure team if you encounter this warning.');
  /* eslint-enable no-console */

  handleSvgFetchError(true);
};